<template>
  <div class="form-group">
    <label
      v-if="label"
      class="col-12 p-0">{{ label }}</label>
    <div
      :class="rootAttrs.className"
      class="time input-group"
      :id="id"
    >
      <input
        :disabled="disabled"
        :value="value"
        @focusout="onChange"
        v-on="listeners"
        :class="rootAttrs.className"
        class="form-control"
      >
      <span class="input-group-addon">
        <span class="fa fa-calendar" />
      </span>
    </div>
  </div>
</template>

<script>
import constants from '@/constants/app.properties';
import uuid from 'uuid/v1';
import bindClick from './bindClick.vue';

export default {
  name: 'VDatePicker',
  mixins: [bindClick],
  props: {
    label: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: String,
      required: true
    },
    format: {
      type: String,
      default: constants.DATE_FORMAT
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: () => []
    },
    maxDate: {
      type: String,
      default: () => null
    },
    minDate: {
      type: String,
      default: () => null
    },
    position: {
      type: String,
      default: 'top'
    }
  },
  data() {
    return {
      config: {
        useCurrent: false,
        format: this.format,
        icons: {
          next: 'fa fa-chevron-right',
          previous: 'fa fa-chevron-left'
        },
        widgetPositioning: {
          vertical: this.position
        }
      },
      id: uuid()
    };
  },
  watch: {
    value: 'setValue'
  }
};
</script>

<style scoped lang="scss">
  @import '../style.scss';
</style>
